/**
 * Contact: booking first, email second, the email-draft form for anyone who prefers to write.
 * Change the words here, never in the components.
 */
export const contactPage = {
  eyebrow: 'Contact',
  titleThin: 'Tell me where',
  titleBold: 'the work gets stuck.',
  lede: 'Book a project introduction, or write. Either way you get a straight answer on whether I can help, and what I would do first.',
  bookTitle: 'Book a project introduction',
  bookBody: 'Pick a time on my calendar. We talk through your process, what is breaking, and whether a defined project makes sense.',
  bookNote: 'Opens my booking calendar in a new tab. Times show in your own time zone.',
  emailTitle: 'Prefer email?',
  faqEyebrow: 'FAQs',
  faqTitle: 'Before you book',
  faqSub: 'Still have a question? Write below.',
  cardTitle: 'Draft an email',
  cardBody: 'Two or three lines is enough: what your business does, what tools you use, and where things fall through.',
}

/** The form. There is no backend: a complete message opens the visitor's own email app with it laid out. */
export const contactForm = {
  first: 'First name',
  last: 'Last name',
  email: 'Your email',
  message: 'What should the system fix?',
  phFirst: 'First name',
  phLast: 'Last name',
  phEmail: 'you@yourbusiness.com',
  phMessage: 'What does your business do? What tools do you use today? Where do leads, jobs or payments fall through?',
  send: 'Open email draft',
  hint: 'This opens your own email app with the message filled in. Nothing is sent until you press send there.',
  error: 'Add your name, a valid email and a short note.',
  sentTitle: 'Your email app should have opened.',
  sentBody: 'The message is addressed and laid out. It has not been sent yet: press send in your email app.',
  noMailApp: 'Nothing opened? Copy the message and write to',
  copy: 'Copy message',
  copied: 'Copied',
  again: 'Edit the message',
}
